export enum UserLevel {
  Default = "Default",
  Hexspoor = "Hexspoor",
  Administrator = "Administrator",
  Supplier = "Supplier",
  Exit = "Exit",
}
